import { styled } from '@mui/material/styles';
import { Box, TableContainer } from '@mui/material';

export const Text = styled(Box)``;

export const Typography = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #000000;
`;

export const Header = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: start;
  letter-spacing: 0.15px;
  color: #212121;
  margin-bottom: 20px;
  flex-direction: column;
  gap: 20px;
  span {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.1px;
    color: #9e9e9e;
  }
`;

export const TableContainerStyles = styled(TableContainer)`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SelectedLabel = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;
